<template>
  <div>
    <el-card shadow="always" style="margin:0 auto;margin-top:5px;">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select v-model="qApiTokenType" placeholder="平台類型" style="width:100%" clearable>
            <el-option label="mitake" value="mitake"></el-option>
            <el-option label="e8d" value="e8d"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="帳號" v-model="qAccount">
            <template slot="prepend">帳號</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="備註" v-model="qNote">
            <template slot="prepend">備註</template>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="pageCurrent=1;query()">查詢</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="always" style="margin:0 auto;margin-top:10px;">
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="apiTokenType" label="平台類型" width="160"></el-table-column>
        <el-table-column prop="account" label="帳號"></el-table-column>
        <el-table-column prop="note" label="備註"></el-table-column>
        <el-table-column prop="updateTime" label="更新時間" width="180"></el-table-column>
        <el-table-column prop="updator" label="更新人" width="120"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="showDetailForm(scope.row)" type="primary" size="small">編輯</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        style="margin-top:10px"
        :page-size="10"
        :total="pageTotal"
        :current-page.sync="pageCurrent"
        @current-change="query">
      </el-pagination>
    </el-card>

    <el-dialog title="編輯簡訊平台帳密" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form" ref="editForm" :rules="rules">
        <el-form-item label="ID" :label-width="formLabelWidth">
          <el-input v-model="form.rowid" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台類型" :label-width="formLabelWidth">
          <el-input v-model="form.apiTokenType" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="帳號" :label-width="formLabelWidth" prop="account">
          <el-input v-model="form.account" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密碼" :label-width="formLabelWidth" prop="password">
          <el-input v-model="form.password" autocomplete="new-password" show-password></el-input>
        </el-form-item>
        <el-form-item label="備註" :label-width="formLabelWidth">
          <el-input v-model="form.note" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">確 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminApiAccessInfo',
  data () {
    return {
      allowedApiTokenTypes: ['mitake', 'e8d'],
      qApiTokenType: '',
      qAccount: '',
      qNote: '',
      pageTotal: 0,
      pageCurrent: 1,
      tableData: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      form: {
        rowid: '',
        apiTokenType: '',
        account: '',
        password: '',
        token: '',
        lifetime: '',
        updateTime: '',
        updator: '',
        note: '',
        extend1: '',
        extend2: ''
      },
      rules: {
        account: [{
          required: true,
          message: '無法為空值',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '無法為空值',
          trigger: 'blur'
        }]
      }
    }
  },
  created () {
    this.$axios
      .get('../api/params/getParams', {})
      .then((res) => {
        this.$store.dispatch('login', res.data)
        if (this.$store.getters.userType !== '0') {
          this.$alert('無權限使用此功能', '結果', { confirmButtonText: '確定' })
          this.$router.push('/')
          return
        }
        this.query()
      }).catch((res) => {
        if (res.response && res.response.status == 401) {
          window.location = '/'
        }
      })
  },
  methods: {
    isAllowedType (apiTokenType) {
      const type = (apiTokenType || '').toLowerCase()
      return this.allowedApiTokenTypes.indexOf(type) !== -1
    },
    unwrapRecord (payload) {
      if (!payload) {
        return {}
      }
      if (payload.data && (payload.data.rowid != null || payload.data.rowId != null)) {
        payload = payload.data
      }
      if (payload.value && (payload.value.rowid != null || payload.value.rowId != null)) {
        payload = payload.value
      }
      return payload
    },
    query () {
      this.$axios
        .get('../api/adminApiAccessInfo/getApiAccessInfos', {
          params: {
            apiTokenType: this.qApiTokenType,
            account: this.qAccount,
            note: this.qNote,
            page: this.pageCurrent
          }
        })
        .then((res) => {
          this.tableData.splice(0, this.tableData.length)
          const list = (res.data && res.data.data) ? res.data.data : []
          list.filter(item => this.isAllowedType(item.apiTokenType)).forEach(item => {
            this.tableData.push(item)
          })
          this.pageTotal = res.data.pageTotal || 0
        }).catch((res) => {
          console.log(res)
          this.$alert('查詢失敗', '結果', { confirmButtonText: '確定' })
        })
    },
    showDetailForm (item) {
      const rowid = item.rowid != null ? item.rowid : item.rowId
      this.$axios
        .get('../api/adminApiAccessInfo/getApiAccessInfo', {
          params: { rowid: rowid }
        })
        .then((res) => {
          const data = this.unwrapRecord(res.data)
          if (!this.isAllowedType(data.apiTokenType)) {
            this.$alert('僅能編輯 mitake / e8d 簡訊平台', '結果', { confirmButtonText: '確定' })
            return
          }
          this.form = {
            rowid: data.rowid != null ? data.rowid : data.rowId,
            apiTokenType: data.apiTokenType || '',
            account: data.account || '',
            password: data.password || '',
            token: data.token || '',
            lifetime: data.lifetime || '',
            updateTime: data.updateTime || '',
            updator: data.updator || '',
            note: data.note || '',
            extend1: data.extend1 || '',
            extend2: data.extend2 || ''
          }
          this.dialogFormVisible = true
          this.$nextTick(() => {
            if (this.$refs.editForm) {
              this.$refs.editForm.clearValidate()
            }
          })
        }).catch((res) => {
          console.log(res)
          this.$alert('取得資料失敗', '結果', { confirmButtonText: '確定' })
        })
    },
    confirmEdit () {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$axios
          .post('../api/adminApiAccessInfo/updateApiAccessInfo', this.form)
          .then(() => {
            this.query()
            this.$notify({
              title: '結果',
              message: '已成功更新',
              type: 'success',
              duration: 4500,
              position: 'top-right',
              showClose: true
            })
            this.dialogFormVisible = false
          }).catch((res) => {
            console.log(res)
            this.$alert('更新失敗', '結果', { confirmButtonText: '確定' })
          })
      })
    }
  }
}
</script>
